import { Student } from "types";
import { api } from "../api";
import { NetworkError } from "../networkError";

interface Params {
  token: string;
  studentId: string;
}

const deleteStudent = async ({ token, studentId }: Params): Promise<Student> => {
  const response = await api.delete(`/students/${studentId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  const deletedStudent = response.data;

  if (deletedStudent) {
    return deletedStudent;
  } else {
    throw new NetworkError();
  }
};

export { deleteStudent };
